module.exports = __webpack_public_path__ + "../resources/img/ic_re_arc_by_qcells_logo_lt.e8f22df0.svg";